import { Component, OnInit, Input } from "@angular/core";
import { ConfigService } from "src/app/services/config/config.service";
import { EventsService } from "src/app/services/event/event.service";
import { PurchaseService } from "src/app/services/purchase/purchase.service";
import { UtilsService } from 'src/app/services/utils/utils.service';
@Component({
  selector: "app-bonus-purchase",
  templateUrl: "./bonus-purchase.component.html",
  styleUrls: ["./bonus-purchase.component.scss"],
})
export class BonusPurchaseComponent implements OnInit {

  @Input() purchase: Purchase;
  @Input() isAuthenticated;

  isTimerActive:boolean = false;
  isTimerActiveEnd:boolean = false;
  basePath = this.config.getConfig().CDN_BASEURL + "/assets/imgs/";
  itemInfo: any
  public widthSize = 0;
  public remainingTimeInSeconds: number = undefined;
  checkTimeout:boolean = true;
  checkTimeoutEnd:boolean = true;

  constructor(public utilsService: UtilsService, private purchaseService: PurchaseService,
    private config:ConfigService, private eventService: EventsService) { }

  ngOnInit() {
    this.settingData();
    this.initTimers();
    this.checkAppState();
  }

  ngOnDestroy() {
    this.checkTimeout = false;
    this.checkTimeoutEnd = false;
    this.eventService.destroy('event:appStateChange');
  }

  checkAppState() {
    this.eventService.subscribe('event:appStateChange', (isActive) => {
      if (isActive) {
        this.updatePremiumBonus();
      } else {
        this.checkTimeoutEnd = false;
        this.checkTimeout = false;
      }
    });
  }

  settingData(){
    this.itemInfo = {
      priceCode: this.purchase.priceCode,
      credits: this.purchase.credits,
      chips: this.purchase.chipsAmount,
      points: this.purchase.points,
      price: this.purchase.priceAmount,
      totalOf:this.purchase.totalOf,
      totalDays:this.purchase.totalDays,
      isAuthenticated: this.isAuthenticated,
      is_premium: true
    }
  }

  initTimers() {
    const currentTimestamp = Date.now();
    if (this.purchase.isActiveBonus && this.purchase.startTime && this.purchase.endTime) {
      const remainingTimeInSeconds = Math.max(0, Math.floor((this.purchase.startTime - currentTimestamp) / 1000));
      const remainingTimeInSecondsEnd = Math.max(0, Math.floor((this.purchase.endTime - currentTimestamp) / 1000));
      if (remainingTimeInSeconds > 0) {
        this.setTimeStart(remainingTimeInSeconds);
      } else if (remainingTimeInSecondsEnd > 0) {
        this.setEndTime(remainingTimeInSecondsEnd);
      }
    }
  }

  onCollectClick() {
    if (this.purchase.premiumChipsDefinition && this.purchase.premiumChipsDefinition.priceCode) {
      this.purchaseService.collectPremiumPurchases(this.purchase.premiumChipsDefinition.priceCode).subscribe((response) => {
        if (response.result == 1) {
          // calling getAvailablePremiumBonus from shop page;
          this.updatePremiumBonus();
        }
      }, (error) => {
        // updating the preimum bonus on error
        this.updatePremiumBonus();
      });
    }
  }

  protected updatePremiumBonus(){
    this.eventService.publish("event:call:getpremium");
  }

  protected setEndTime(timeLeft: number){
    this.isTimerActiveEnd = false
    if (timeLeft != 0 && this.checkTimeoutEnd) {
      this.isTimerActiveEnd = true;
      setTimeout(() => this.setEndTime(timeLeft - 1), 1000);
    }
    if (!this.isTimerActiveEnd && this.checkTimeoutEnd) {
      this.checkTimeoutEnd = false;
      this.updatePremiumBonus();
    }
  }

  protected setTimeStart(timeLeft: number) {
    this.remainingTimeInSeconds = timeLeft;
    this.isTimerActive = false
    if (timeLeft != 0 && this.checkTimeout) {
      this.isTimerActive = true;
      setTimeout(() => this.setTimeStart(timeLeft - 1), 1000);
    }
    if (!this.isTimerActive && this.checkTimeout) {
      this.checkTimeout = false;
      this.updatePremiumBonus();
    }
  }
}


export interface Purchase {
  leftImage: string,
  rightImage?: string,
  chips?: number;
  days?: number,
  price?: string,
  credits?: string,
  points?: string,
  isAuthenticated: boolean,
  total?: string,
  totalOf?: string,
  priceCode?: string
  startTime?: number
  endTime?: number,
  totalDays?: number,
  currentDay?: number,
  chipsAmount?:number,
  priceAmount?:number,
  premiumChipsDefinition?: any,
  isActiveBonus?:boolean,
  currentDayStatus:string
}

